var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',_vm._b({staticClass:"button-link",attrs:{"type":_vm.color,"outlined":"","size":_vm.size,"icon-left":_vm.icon,"loading":_vm.loading},on:{"click":function($event){return _vm.$emit('click', $event)}}},'b-button',_vm.$attrs,false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }